module.exports = __webpack_public_path__ + "img/72.d73bf6eb.png";